export enum ChartControlTypeEnum {
  Statistics = 1,
  Echarts = 2,
  Scatter = 2,
  AgGrid = 3,
  TextAnalytics = 6,
  NumericChart = 7,
  NumberBox = 8,
  TextBox = 13,
  ImageBox = 17,
}
